import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { ICrudGetAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntity } from './video-meta-data-keywords.reducer';
import { IVideoMetaDataKeywords } from 'app/shared/model/video-meta-data-keywords.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface IVideoMetaDataKeywordsDetailProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export const VideoMetaDataKeywordsDetail = (props: IVideoMetaDataKeywordsDetailProps) => {
  useEffect(() => {
    props.getEntity(props.match.params.id);
  }, []);

  const { videoMetaDataKeywordsEntity } = props;
  return (
    <Row>
      <Col md="8">
        <h2>
          VideoMetaDataKeywords [<b>{videoMetaDataKeywordsEntity.id}</b>]
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="keywordName">Keyword Name</span>
          </dt>
          <dd>{videoMetaDataKeywordsEntity.keywordName}</dd>
          <dt>Video Meta Data</dt>
          <dd>{videoMetaDataKeywordsEntity.videoMetaData ? videoMetaDataKeywordsEntity.videoMetaData.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/video-meta-data-keywords" replace color="info">
          <FontAwesomeIcon icon="arrow-left" /> <span className="d-none d-md-inline">Back</span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/video-meta-data-keywords/${videoMetaDataKeywordsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
        </Button>
      </Col>
    </Row>
  );
};

const mapStateToProps = ({ videoMetaDataKeywords }: IRootState) => ({
  videoMetaDataKeywordsEntity: videoMetaDataKeywords.entity,
});

const mapDispatchToProps = { getEntity };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(VideoMetaDataKeywordsDetail);
